export default {
    data() {
        return {
            discountedAmount: 0.0,
        }
    },
    methods: {
        fetchBranchMenu: function () {
            this.menu = [];
            this.itemOptions = [];
            let params3 = new URLSearchParams();
            params3.append("branch_id", this.order.branchesByBranchId.id);
            this.$http.post(this.$store.state.mainAppURL + "restaurants/get_branch_menu", params3).then(resp => {
                this.menu = resp.data;
                this.menu.forEach((mCategory) => {
                    mCategory.menuItemsById.forEach((menuItem) => {
                        menuItem.menuItemTypesById.forEach((menuItemType) => {
                            let option = { id:menuItemType.id , categoryName:mCategory.name , menuItemName:menuItem.name , serving:menuItemType.serving};
                            this.itemOptions.push(option);
                        })
                    })
                });
                if(this.order.couponsByCouponId !== null) {
                    if (this.order.branchesByBranchId.couponById.inPercentage === false) {
                        this.discountedAmount = this.order.branchesByBranchId.couponById.discount;
                    } else
                        this.discountedAmount = this.order.branchesByBranchId.couponById.discount / 100;
                }
                this.isHideSpinner = "hide";
            }).catch(ex => {
                this.isHideSpinner = "hide";
                swal("Error!", ex + " Please try again or Contact DVM Tech Support", "error");
            });
        },
    }
}